module.exports = __webpack_public_path__ + "img/icon-low-traffic-high-impressions.a07aa34f.svg";